import axios from "../http"; // 导入axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getCoupon ={
    getCouponLists(params) {
        return axios.post(`/mobile/page/pc_my_coupon_list`,qs.stringify(params));
    },
    getMyCouponHistory(params) {
        return axios.post(`/mobile/page/pc_my_coupon_history`,qs.stringify(params));
    },
    getPacketLists(params) {
        return axios.post(`/mobile/page/pc_packet_list`,qs.stringify(params));
    },
    //积分优惠券
    jifen_coupon(params) {
        return axios.post(`/mobile/page/jifen_coupon`,qs.stringify(params));
    },
    //积分商城
    integral_cate_lists_all(params) {
        return axios.post(`/mobile/page/integral_cate_lists_all`,qs.stringify(params));
    },
    redeem_lists(params) {
        return axios.post(`/mobile/page/redeem_lists`,qs.stringify(params));
    },
}
export default getCoupon;


// WEBPACK FOOTER //
// ./src/assets/js/api/require/coupon.js